"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _profile = require("@widget/profile");

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _Route = _interopRequireDefault(require("./Route"));

var _Routes = _interopRequireDefault(require("../abstracts/Routes"));

function checkPermissions() {
  var profilePermissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var permissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var result = [];

  for (var i = 0; i < permissions.length; i++) {
    if (permissions.hasOwnProperty(i)) {
      var routePerm = permissions[i];
      result.push(profilePermissions.includes(routePerm));
    }
  }

  return !result.includes(false);
}

var SwitchRoutes = /*#__PURE__*/function (_AbstractRoutes) {
  (0, _inherits2["default"])(SwitchRoutes, _AbstractRoutes);

  var _super = (0, _createSuper2["default"])(SwitchRoutes);

  function SwitchRoutes() {
    (0, _classCallCheck2["default"])(this, SwitchRoutes);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SwitchRoutes, [{
    key: "renderRoutes",
    value: function renderRoutes(profile) {
      var _this = this;

      return this.config.routes.map(function (item) {
        var _profile$user;

        if (profile !== null && profile !== void 0 && (_profile$user = profile['user']) !== null && _profile$user !== void 0 && _profile$user['permissions']) {
          if (item['permissions']) {
            var _profile$user2;

            var hasPerm = checkPermissions(profile === null || profile === void 0 ? void 0 : (_profile$user2 = profile['user']) === null || _profile$user2 === void 0 ? void 0 : _profile$user2['permissions'], item['permissions']);

            if (!hasPerm) {
              return null;
            }
          }
        }

        var route = new _Route["default"](item, _this.config);
        return route.render();
      });
    }
  }, {
    key: "render",
    value: function render() {
      return function () {
        var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
        var routes = this.renderRoutes(profile);
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, routes.map(function (route) {
          return route ? route() : null;
        }));
      }.bind(this);
    }
  }]);
  return SwitchRoutes;
}(_Routes["default"]);

var _default = SwitchRoutes;
exports["default"] = _default;